import { render } from "./Header.vue?vue&type=template&id=6460adf1&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=6460adf1&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6460adf1"]])

export default __exports__